export class ContainerPrice {
  constructor(
    private name: string,
    private value: number,
  ) {}

  public getName() {
    return this.name;
  }

  public getValue() {
    return this.value;
  }

  public setValue(param: number) {
    this.value = param;
  }
}
